import "moment/locale/pt-br";

function Licence() {
  return (
    <div
      id="licence"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h2 className="mb-5">
          Já te falei do sindicato algumas vezes, mas dessa vez eles fizeram um
          ótimo trabalho, emitiram uma licença pra mim, acredita? É verdade!
        </h2>
        <hr />
        <h1 className="mt-5">Licença nº 0001</h1>
        <br />
        <h4>
          Concedida a: Gabriel
          <br />
          Beneficiária: Responsável pelos meus melhores dias
        </h4>
        <br />

        <h4>
          Art. 1º — Fica concedido o direito de pensar em Tissy ao acordar, ao
          dormir, ao escutar uma música aleatória e sempre que algo for "lindo
          demais pra não lembrar dela".
        </h4>
        <br />
        <h4>
          Art. 2º — O titular desta licença poderá, sem aviso prévio, declarar
          “eu te amo” em qualquer contexto, inclusive mas não limitado a: filas,
          elevadores, mensagens aleatórias às 14h37, ou quando der vontade.
        </h4>
        <br />
        <h4>
          Art. 3º — Está assegurado o direito de cuidar dela, mesmo que ela diga
          “tô bem, juro” ou "não é nada, tá tudo bem".
        </h4>
        <br />
        <h4>
          Art. 4º — A saudade, mesmo que irracional, será considerada motivo
          legítimo para enviar memes, figurinhas, fotos ou “só queria te ver e
          ouvir sua voz”.
        </h4>
        <br />
        <h4>
          Art. 5º — O titular compromete-se a conhecer e respeitar todas as
          versões de Tissy: a tagarela, a quieta, a filosófica, a com fome, a
          realista e a sonhadora.
        </h4>
        <br />
        <h4>
          Art. 6º — Beijos devem ser distribuídos em quantidade generosa, com
          prioridade para boca, bochecha, testa e qualquer parte que estiver
          “precisando de carinho”.
        </h4>
        <br />
        <h4>
          Art. 7º — Em caso de dúvida, escolher sempre o caminho que a faça
          sorrir — especialmente se envolver cervejinha, vinho, cobertor ou
          massagem.
        </h4>
      </div>
    </div>
  );
}

export default Licence;
